import gql from 'graphql-tag';

import categoryFragment from '~/shared/graphql-queries/categories/category-fragment';

export default gql`
  mutation createOneCategoryMutation($record: CreateOneCategoryInput!) {
    createOneCategoryMutation(record: $record) {
      recordId
      record {
        ...CategoryFragment
      }
      message
      title
    }
  }
  ${categoryFragment}
`;
